import NotificationService from '@/services/NotificationService'
import moment from 'moment'
import BaseModel from './base'

export enum NotificationType {
  NOTIFICATION_TYPE_SMS = 'sms',
  NOTIFICATION_TYPE_FACEBOOK_MESSENGER = 'fb_messenger',
  NOTIFICATION_TYPE_REVIEW = 'review',
  NOTIFICATION_TYPE_CALL = 'call',
  NOTIFICATION_TYPE_REVIEW_REPLY = 'reviewReply',
  NOTIFICATION_TYPE_APPOINTMENT = 'appointment',
  NOTIFICATION_TYPE_EMAIL = 'email',
  NOTIFICATION_TYPE_SILENT = 'silent',
  NOTIFICATION_CUSTOM = 'custom',
  NOTIFICATION_TYPE_SNAPSHOT = 'snapshot',
  NOTIFICATION_TYPE_VOICEMAIL = 'voicemail',
  NOTIFICATION_TYPE_GMB = 'gmb',
  NOTIFICATION_TYPE_INSTAGRAM = 'instagram',
  NOTIFICATION_TYPE_CONVERSATION_INITIATED = 'conversation_initiated',
  NOTIFICATION_TYPE_CONVERSATION_ASSIGNED = 'conversation_assigned',
  NOTIFICATION_TYPE_TASK_ASSIGNED = 'task_assigned',
  NOTIFICATION_TYPE_TASK_REMINDER = 'task_reminder',
  NOTIFICATION_TYPE_DAILY_DUE_TASK_SUMMARY = 'daily_due_task_summary',
  NOTIFICATION_TYPE_DAILY_OVERDUE_TASK_SUMMARY = 'daily_overdue_task_summary',
  NOTIFICATION_TYPE_APPOINTMENT_ASSIGNED = 'appointment_assigned',
  NOTIFICATION_TYPE_LIVE_CHAT = 'live_chat',
  NOTIFICATION_TYPE_WHATSAPP = 'whatsapp',
  NOTIFICATION_TYPE_INTERNAL_COMMENT_MENTION = 'internal_comment_mentions',
  NOTIFICATION_TYPE_LISTINGS = 'listings',
  NOTIFICATION_TYPE_LISTINGS_SCHEDULED_REPORTS = 'listings_scheduled_reports',
  NOTIFICATION_TYPE_WORDPRESS = 'wordpress',
  NOTIFICATION_TYPE_INTERNAL_CHAT_CONVERSATION = 'INTERNAL_CHAT_CONVERSATION',
  NOTIFICATION_TYPE_INTERNAL_CHAT_MESSAGE = 'INTERNAL_CHAT_MESSAGE',
  NOTIFICATION_TYPE_REPUTATION_DATASHAKE = 'reputation_datashake',
  NOTIFICATION_TYPE_CALENDAR_INTEGRATION_DISCONNECTED = 'CALENDAR_INTEGRATION_DISCONNECTED',
  NOTIFICATION_TYPE_REPUTATION_GMB_REVIEW = 'reputation_gmb_review',
  NOTIFICATION_TYPE_SOCIAL_PLANNER_PVPN = 'social_planner_pvpn',
  NOTIFICATION_TYPE_TIKTOK = 'tiktok',
}

export enum NotificationSubType {
  SNAPSHOT_PUSH_ROLLING = 'snapshot_push_rolling',
}

export enum NotificationSubType {
  SNAPSHOT_PUSH_ROLLING = 'snapshot_push_rolling',
}

export enum NotificationSubType {
  SNAPSHOT_PUSH_ROLLING = 'snapshot_push_rolling',
}

export enum CustomNotificationType {
  CONTACT = 'contact',
  BULK_ACTIONS = 'bulk-actions',
  OPPORTUNITY = 'opportunity',
  CONVERSATION = 'conversation',
  INSTAGRAM_STORY = 'instagram_story',
  EXTERNAL = 'external',
  MEMBERSHIP = 'membership',
  CLIENT_PORTAL_BRANDED_APP = 'client_portal_branded_app',
}

export interface INotification {
  _id: string
  notificationData: NotificationType
  locationId: string
  type: string
  read: boolean
  userId: string
  deleted: boolean
}

export default class Notification extends BaseModel {
  static requestBodyWhiteList = ['deleted', 'userId', 'read', 'notificationData', 'locationId', 'type']

  // Methods
  constructor(data: INotification) {
    super(Notification.requestBodyWhiteList, data)
  }

  async save(): Promise<{ [key: string]: any }> {
    return new Promise(async (resolve, reject) => {
      try {
        let response: { [key: string]: any } = {}
        if (!this.newRecord) {
          response = await NotificationService.update(this.id, this.updatedData)
        }
        resolve(response)
      } catch (error) {
        reject(error)
      }
    })
  }

  static async getByUserId(userId, query): Promise<Notification[]> {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await NotificationService.getByUserId(userId, query)
        resolve(response.notifications.map(n => new Notification(n)))
      } catch (error) {
        reject(error)
      }
    })
  }

  static async markAsReadByUserId(userId): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      try {
        await NotificationService.updateByUserId(userId, { read: true })
        resolve(true)
      } catch (error) {
        reject(error)
      }
    })
  }

  static async deleteByUserId(userId): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      try {
        await NotificationService.deleteByUserId(userId)
        resolve(true)
      } catch (error) {
        reject(error)
      }
    })
  }

  static async markAsReadByNotificationId(notificationId): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      try {
        await NotificationService.update(notificationId, { read: true })
        resolve(true)
      } catch (error) {
        reject(error)
      }
    })
  }

  // Getters and Setters
  get locationId(): string {
    return this.data.locationId
  }

  set locationId(locationId: string) {
    this.data.locationId = locationId
  }

  get userId(): string {
    return this.data.userId
  }

  set userId(userId: string) {
    this.data.userId = userId
  }

  get type(): string {
    return this.data.type
  }

  set type(type: string) {
    this.data.type = type
  }

  get notificationData(): { [key: string]: any } {
    return this.data.notificationData
  }

  set notificationData(notificationData: { [key: string]: any }) {
    this.data.notificationData = notificationData
  }

  get read(): boolean {
    return this.data.read || false
  }

  set read(read: boolean) {
    this.data.read = read
    this.updatedData.read = read
  }

  get deleted(): boolean {
    return this.data.deleted
  }

  get timeCalendar(): string {
    return moment(new Date(this.dateAdded)).calendar()
  }
}
